export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "bundle.668aa85ca175a3528cdb.worker.js");
}
